module.exports = __webpack_public_path__ + "assets/img/3e4004e67c893e2f815fd6bebca5e07f.svg";